/**
 * Leading segment of a petition's localized relevant-location name.
 *
 * `relevantLocationLocalizedName` is a comma-joined path - "Los Angeles, CA", "Bigfoot, Texas, US" -
 * but copy like "[location] leaders" reads as a single place, so only the leading segment is used.
 *
 * Splitting on a comma is a known heuristic: it holds for locales that format the name
 * most-specific-first and picks the wrong segment for any that do not. Accepted over rendering the
 * whole path; a dedicated city field on the query is the alternative worth revisiting.
 */
export function getLocationLabel(relevantLocationLocalizedName: string | null | undefined): string | undefined {
	const [firstSegment] = (relevantLocationLocalizedName ?? '').split(',');

	return firstSegment.trim() || undefined;
}
